import { useState } from 'react';

import PublicHttpClient from '../../shared/infrastructures/clients/public-http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { PUBLIC_AUTHENTICATION_API_PATHS } from '../constants/authentication-paths.constants';
import { AuthenticatedUser, SignupRequestDTO } from '../types/authentication.dto';

const FALLBACK_MESSAGE = 'La création du compte a échoué';

type UseSignupResult = {
  isSubmitting: boolean;
  error: string | null;
  submit: (payload: SignupRequestDTO) => Promise<AuthenticatedUser | null>;
};

export function useSignup(): UseSignupResult {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: SignupRequestDTO): Promise<AuthenticatedUser | null> => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await PublicHttpClient.post<{ user: AuthenticatedUser }, SignupRequestDTO>(
        PUBLIC_AUTHENTICATION_API_PATHS.SIGNUP,
        payload
      );

      return response.user;
    } catch (caught) {
      setError(extractApiErrorMessage(caught, FALLBACK_MESSAGE));

      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, error, submit };
}
